module.exports = __webpack_public_path__ + "files/3080dbd32c5764e915be872b7d540117.png";